var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7931a",
    d: "M23.641 14.903c-1.603 6.428-8.114 10.34-14.543 8.738S-1.242 15.527.362 9.098C1.964 2.67 8.475-1.244 14.902.36c6.43 1.603 10.342 8.115 8.739 14.544z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.293 10.29c.239-1.597-.977-2.455-2.64-3.028l.54-2.163-1.317-.328-.525 2.106a55 55 0 0 0-1.055-.248l.529-2.12-1.316-.328-.54 2.162q-.431-.097-.84-.198V6.14l-1.815-.454-.35 1.407s.976.224.956.237c.533.133.63.486.614.766l-.615 2.465a1 1 0 0 1 .137.043l-.038-.009-.101-.025-.861 3.452c-.065.162-.23.405-.604.313.014.02-.957-.239-.957-.239l-.653 1.508 1.713.427q.282.07.557.143l.382.1-.545 2.187 1.315.328.54-2.165q.538.146 1.05.273l-.538 2.154 1.316.328.545-2.183c2.246.424 3.934.253 4.645-1.778.572-1.635-.029-2.578-1.21-3.193.86-.199 1.508-.765 1.681-1.934zm-3.009 4.22c-.373 1.5-2.722.88-3.796.595l-.256-.066.723-2.899q.136.033.323.075c1.112.25 3.389.76 3.006 2.294zm-2.783-3.64c.896.239 2.85.76 3.19-.603.348-1.395-1.551-1.815-2.479-2.02q-.157-.035-.271-.063l-.656 2.629q.094.024.216.056z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.3682934023ed7946a2c9593d1313deb4.svg";
export { ForwardRef as ReactComponent };